// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const tentacruel: PokeData = {
  "id": 73,
  "name": "tentacruel",
  "height": 16,
  "weight": 550,
  "base_experience": 180,
  "types": [
    PokeType.WATER,
    PokeType.POISON
  ],
  "api_moves": [
    "wrap",
    "poison-sting",
    "supersonic",
    "acid",
    "water-gun",
    "hydro-pump",
    "surf",
    "bubble-beam",
    "screech",
    "barrier",
    "haze",
    "constrict",
    "bubble",
    "acid-armor",
    "mirror-coat",
    "water-pulse",
    "brine",
    "wring-out",
    "toxic-spikes",
    "poison-jab",
    "sludge-wave",
    "acid-spray",
    "hex",
    "reflect-type"
  ],
  "moves": [
    "supersonic",
    "acid",
    "hydro-pump",
    "bubble-beam",
    "bubble",
    "brine",
    "toxic-spikes",
    "poison-jab",
    "life-dew",
    "sludge-bomb",
    "poison-fang",
    "purify",
    "liquidation"
  ],
  "evolution_chain": {
    "id": 30,
    "item": null,
    "species": [
      {
        "name": "tentacool",
        "order": 78,
        "types": [
          PokeType.WATER,
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "tentacruel",
        "order": 79,
        "types": [
          PokeType.WATER,
          PokeType.POISON
        ],
        "evolves_from_species_id": 72,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 130,
    "speed": 150,
    "ability_power": 120
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
